import { render, staticRenderFns } from "./UserDeactivateDialog.vue?vue&type=template&id=e341d1f0&scoped=true"
import script from "./UserDeactivateDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserDeactivateDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e341d1f0",
  null
  
)

export default component.exports